module.exports = __webpack_public_path__ + "img/volume_down.eabf3552.svg";